type KeyedRow = Record<string, any> | null | undefined

export const addressKeyOf = (row: KeyedRow) => `${row?.address}-${row?.index}`

export const rowKeyOf = (row: KeyedRow) =>
  row?.id ? String(row.id) : `${row?.twiId ?? 0}:${addressKeyOf(row)}`

export const stationDecoderKeyOf = (station: KeyedRow) =>
  station?.decoderId ? String(station.decoderId) : addressKeyOf(station)

export const getByDecoder = <T>(map: Map<string, T>, row: KeyedRow): T | undefined =>
  (row?.id ? map.get(String(row.id)) : undefined) ?? map.get(addressKeyOf(row))

export const hasByDecoder = (keys: Set<string>, row: KeyedRow) =>
  (!!row?.id && keys.has(String(row.id))) || keys.has(addressKeyOf(row))

export const isSamePhysicalDecoder = (a: KeyedRow, b: KeyedRow) =>
  String(a?.address) === String(b?.address) &&
  (Number(a?.twiId) || 0) === (Number(b?.twiId) || 0)

export const isLegacyAddressKey = (key: string) => /^\d+-\d+$/.test(key)
